import {
  Checkbox,
  Col,
  Divider,
  Input,
  Radio,
  Row,
  Select,
  Tooltip,
} from "antd";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertFromRaw,
} from "draft-js";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { FaDownload, FaUpload } from "react-icons/fa";
import { GoDeviceMobile } from "react-icons/go";
import { IoMdCloseCircle } from "react-icons/io";
import { IoInformationCircleSharp } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { RiImageAddFill } from "react-icons/ri";
import {
  category,
  colorScheme,
  colors,
  mileages,
} from "../../contants/variables";
import {
  IconButton,
  PrimaryButton,
} from "../../custom_components/customButton";
import { uploadImage } from "../../stores/api_calls/upload";
import { getCommaSeparatedTwoDecimalsNumber } from "../../stores/utils/formatNumber";
import "./carform.scss";
import VideoUploader from "./VideoUploader";

const launchYears = [];
const lastYear = moment().add(1, "y").format("YYYY");
for (var i = 2023; i <= lastYear; i++) {
  launchYears.push(i.toString());
}

const FieldSuffix = (props) => {
  const { TooltipData } = props;
  return (
    <Tooltip
      title={() => {
        return <TooltipData />;
      }}
      placement="bottomRight"
    >
      <IoInformationCircleSharp
        color={colorScheme.primary}
        style={{ fontSize: "20px" }}
      />
    </Tooltip>
  );
};

const ImageUploadComponent = (props) => {
  const { onChange } = props;
  const fileUploader = useRef(null);

  const uploadImageCallBack = (link) => {
    onChange(link, "auto", "100%", "uploaded image");
  };

  const onSelectFile = (e) => {
    const file = e.target.files[0];
    // const localUrl = URL.createObjectURL(file)

    const upload = uploadImage(file);

    upload
      .then((res) => {
        if (res.data.success) {
          console.log(res.data.data);
          const url = res.data.data.metadata.image_url;
          uploadImageCallBack(url);
        }
      })
      .catch((e) => {
        error(
          `Opps! ${e.response.data.server_response} . Upload Failed. Please try again`,
        );
      });
  };

  const handleOpenGallery = (event) => {
    fileUploader.current.click();
  };

  return (
    <div>
      <div className="icon-button-div">
        <IconButton
          className="icon-button upload"
          tootTipTitle="Upload Image"
          Icon={<RiImageAddFill />}
          onClick={handleOpenGallery}
        />
      </div>

      <input
        ref={fileUploader}
        hidden
        type="file"
        name="image-event"
        id="image-event"
        accept="image/*"
        onChange={onSelectFile}
      />
    </div>
  );
};

const NewCarDetails = (props) => {
  const [downloading, setDownloading] = useState(false);
  const fileUploaderLong1 = useRef(null);
  // const fileUploaderLong2 = useRef(null);
  const [salesAgents, setSalesAgents] = useState([]);

  // const [specsEditorState, setSpecsEditorState] = useState(() =>
  //   EditorState.createEmpty()
  // );
  const [acceEditorState, setAcceEditorState] = useState(() =>
    EditorState.createEmpty(),
  );
  const [featEditorState, setFeatEditorState] = useState(() =>
    EditorState.createEmpty(),
  );
  const [descEditorState, setDescEditorState] = useState(() =>
    EditorState.createEmpty(),
  );

  const {
    form,
    setForm,
    brands,
    models,
    dealers,
    packages,
    isEdit,
    newCarVehicleTypes,
    selectedFile1,
    setSelectedFile1,
    newCarConditions,
    saleAdvisers,
    fuelTypes,
  } = props;

  useEffect(() => {
    if (form.featFormatted) {
      setFeatEditorState(getEditorContent(form.featFormatted, "featFormatted"));
    }
    if (form.acceFormatted) {
      setAcceEditorState(getEditorContent(form.acceFormatted, "acceFormatted"));
    }
    if (form.descFormatted) {
      setDescEditorState(getEditorContent(form.descFormatted, "descFormatted"));
    }
  }, [form]);

  const isValidRawContentState = (rawContentState) => {
    return (
      rawContentState && rawContentState.blocks && rawContentState.entityMap
    );
  };

  const getEditorContent = (editorState, type) => {
    if (typeof editorState === "object") {
      if (isValidRawContentState(editorState)) {
        const contentState = convertFromRaw(editorState);
        setForm((previous) => {
          return {
            ...previous,
            [type]: EditorState.createWithContent(contentState),
          };
        });
        return EditorState.createWithContent(contentState);
      } else {
        return editorState;
      }
    } else if (typeof editorState === "string") {
      const descHTML = "<p>" + editorState + "</p>";
      const descBlocksFromHTML = convertFromHTML(descHTML);
      const descContentState = ContentState.createFromBlockArray(
        descBlocksFromHTML.contentBlocks,
        descBlocksFromHTML.entityMap,
      );
      setForm((previous) => {
        return {
          ...previous,
          [type]: EditorState.createWithContent(descContentState),
        };
      });
      return EditorState.createWithContent(descContentState);
    } else {
      return EditorState.createEmpty();
    }
  };

  useEffect(() => {
    setSalesAgents(form.productAgents);
  }, [form, isEdit]);

  const handleUpdateAgent = (e) => {
    const { name, checked } = e.target;

    const contactNumber = name.contactnumber
      ? name.contactnumber
      : name.contactNumber;
    if (checked) {
      salesAgents.push({
        fullName: name.fullName,
        contactNumber: contactNumber,
        sorting: name.sorting,
      });
    } else {
      salesAgents = salesAgents.filter(
        (item) => item.fullName != name.fullName,
      );
    }
    console.log(salesAgents);
    setForm({ ...form, productAgents: salesAgents });
  };

  const handleFieldChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.value,
    });
  };

  const handleNumberFieldChange = (name, e, maxLength = 7) => {
    if (e.length <= maxLength || e == 0) {
      if (name == "engineCap") {
        setForm({
          ...form,
          specifications: {
            ...form.specifications,
            [name]: { label: e + " CC", value: parseInt(e), type: "engine" },
          },
        });
      } else if (name == "peakPower") {
        setForm({
          ...form,
          specifications: {
            ...form.specifications,
            [name]: { label: e + " KW", value: parseInt(e), type: "engine" },
          },
        });
      } else {
        setForm({
          ...form,
          [name]: e,
        });
      }
    }
  };

  const handleSelectPackage = (value) => {
    setForm({ ...form, packageId: value });
  };

  const onCheckboxChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.checked,
    });
  };

  const handleDropdownChange = (name, value, label, type) => {
    if (type == "engine" || type == "transmission") {
      setForm({
        ...form,
        specifications: {
          ...form.specifications,
          [name]: { label: label, value: value, type: type },
        },
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  const handleRadioChange = (key, e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handelVideoChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  function downloadFiles() {
    form?.brochures?.forEach((url, index) => {
      const filename = `file${index + 1}.${getFileType(url)}`; // Generate filename for each file (e.g., file1.pdf, file2.pdf, ...)
      downloadSingleFile(url, filename); // Call downloadFile function for each file URL
    });
  }

  function getFileType(text) {
    const parts = text.split(".");
    return parts[parts.length - 1];
  }

  function downloadSingleFile(url, filename) {
    window.open(url, "_blank");
  }

  // const handleSpecsEditorChange = (state) => {
  //    setSpecsEditorState(state);
  //     setForm({
  //       ...form,
  //       ['specsFormatted']: state,
  //     });
  //  };
  const handleAcceEditorChange = (state) => {
    setAcceEditorState(state);
    setForm({
      ...form,
      ["acceFormatted"]: state,
    });
  };

  const handleFeatEditorChange = (state) => {
    setFeatEditorState(state);
    setForm({
      ...form,
      ["featFormatted"]: state,
    });
  };

  const handleDescEditorChange = (state) => {
    setDescEditorState(state);
    setForm({
      ...form,
      ["descFormatted"]: state,
    });
  };

  const handleOpenGalleryLong1 = (event) => {
    fileUploaderLong1.current.click();
  };

  const handleDeleteSelectedFile1 = () => {
    setForm({ ...form, selectedLongAdFile1: null, longAdImage1: "" });
  };

  const handleImageChange1 = (e) => {
    setSelectedFile1({ ...selectedFile1, file: null, url: "" });

    if (e.target.files) {
      const file = e.target.files[0];
      const localUrl1 = URL.createObjectURL(file);
      setSelectedFile1({ ...selectedFile1, file: file, url: localUrl1 });
      setForm({ ...form, longAdImage1: localUrl1 });
    }
  };

  // const handleOpenGalleryLong2 = (event) => {
  //   fileUploaderLong2.current.click();
  // };

  // const handleDeleteSelectedFile2 = () => {
  //   setForm({...form , selectedLongAdFile2:null, longAdImage2:""})
  // }

  // const handleImageChange2 = (e) => {
  //   setSelectedFile2({ ...selectedFile2, file: null, url: "" });

  //   if (e.target.files) {
  //     const file = e.target.files[0]
  //     const localUrl2 = URL.createObjectURL(file)
  //     setSelectedFile2({ ...selectedFile2, file: file, url: localUrl2 });
  //     setForm({...form , longAdImage2:localUrl2})
  //   }

  // }

  return (
    <div>
      <div className="header-container">
        <p className="header">Dealer Personal Details</p>
        <p className="sub-header">
          note: (*) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Name <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.fullname || undefined}
              loading={dealers.loading}
              onChange={(value) => handleDropdownChange("dealerId", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {[
                {
                  user_first_name: "NOT ON THE LIST DEALER",
                  user_last_name: "",
                  _id: "0",
                },
                {
                  user_first_name: "NOT ON THE LIST DIRECT SELLER",
                  user_last_name: "",
                  _id: "1",
                },
                ...dealers.data,
              ].map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {`${el.user_first_name} ${el.user_last_name}`}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Mobile Number <span>*</span> :{" "}
            </p>
            <Input
              value={form.dealerMobileNumber}
              prefix={<GoDeviceMobile />}
              onChange={(text) => handleFieldChange("dealerMobileNumber", text)}
              disabled={
                form.dealerId === "0" || form.dealerId === "1" ? false : true
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Email:</p>
            <Input
              value={form.dealerEmail}
              prefix={<MdEmail />}
              onChange={(text) => handleFieldChange("dealerEmail", text)}
              disabled={
                form.dealerId === "0" || form.dealerId === "1" ? false : true
              }
            />
          </div>
        </Col>
      </Row>

      {(form.dealerId === "0" || form.dealerId === "1") && (
        <Row>
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">
                First Name <span>*</span> :{" "}
              </p>
              <Input
                value={form.dealerFirstName}
                onChange={(text) => handleFieldChange("dealerFirstName", text)}
              />
            </div>
          </Col>
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Last Name: </p>
              <Input
                value={form.dealerLastName}
                onChange={(text) => handleFieldChange("dealerLastName", text)}
              />
            </div>
          </Col>
        </Row>
      )}

      <Divider />

      {form.role === "Advertiser" ? (
        <div>
          <div className="header-container">
            <p className="header">Package Options</p>
            <p className="sub-header">
              note: (*) for advertisers they must select a plan
            </p>
          </div>

          <Row>
            {packages.map((item, index) => (
              <Col span={8} key={index}>
                <div
                  className={`package-card-container ${
                    form.packageId === item._id ? "active" : ""
                  }`}
                  onClick={() => handleSelectPackage(item._id)}
                >
                  <div className="package-title">
                    <p>{item.package_name}</p>
                    <p>S$ {item.package_cost}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <Divider />
        </div>
      ) : null}

      {/* <div className="header-container">
        <p className="header">Car Details</p>
        <p className="sub-header">
          note: (*) fields are required to be filled up
        </p>
      </div> */}

      <div className="header-container">
        <p className="header">Car Details</p>
        <p className="sub-header">
          note: (*) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Title <span>*</span> :{" "}
            </p>
            <Input
              value={form.carName}
              onChange={(text) => handleFieldChange("carName", text)}
              maxLength={60}
              showCount
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p>
                      <strong>Car Brand & display as Title</strong>
                      <br />
                      Eg: Toyota 1.5A Vios
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Selling Price <span>*</span> :{" "}
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>BND</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.askingPrice)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "askingPrice",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                  7,
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Est Mth Instl. : </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>BND</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(
                form.monthly_installment_price,
              )}
              onChange={(e) => {
                handleNumberFieldChange(
                  "monthly_installment_price",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                  5,
                );
              }}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p>You may enter estimated monthly instalment plan.</p>
                  )}
                />
              }
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Brand <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.carBrand || undefined}
              loading={brands.loading}
              onChange={(value) => handleDropdownChange("carBrand", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {brands.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Car Model <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.carModel || undefined}
              disabled={!models.data.length}
              loading={models.loading && form.carBrand}
              onChange={(value) => handleDropdownChange("carModel", value)}
              style={{ width: "100%" }}
              placeholder={
                models.loading
                  ? `Fetching list of models`
                  : !models.data.length
                    ? `No model available in this brand`
                    : `Search to Select`
              }
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {models.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Built In Country : </p>
            <Input
              value={form.builtIn}
              onChange={(text) => handleFieldChange("builtIn", text)}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Mileage :</p>
            <Select
              showSearch
              value={form.mileage}
              onChange={(value) => handleDropdownChange("mileage", value)}
              style={{ width: "100%" }}
              placeholder="-- Select --"
              options={mileages}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Fuel Type : </p>
            <Select
              showSearch
              value={form.specifications?.fuelType?.value || null}
              onChange={(value) =>
                handleDropdownChange("fuelType", value, "Fuel Type", "engine")
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.children
              //     .toLowerCase()
              //     .localeCompare(optionB.children.toLowerCase())
              // }
            >
              {fuelTypes.map((fuel, i) => (
                <Select.Option key={i} value={fuel}>
                  {fuel}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label"> Car Condition :</p>
            <Select
              showSearch
              value={form.new_condition}
              onChange={(value) => handleDropdownChange("new_condition", value)}
              style={{ width: "100%" }}
              placeholder="-- Select --"
              options={newCarConditions}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Category : </p>
            <Select
              showSearch
              value={form.newCategory}
              onChange={(value) => handleDropdownChange("newCategory", value)}
              style={{ width: "100%" }}
              placeholder={"Select category"}
            >
              {category.map((el, i) => (
                <Select.Option key={i} value={el}>
                  {el}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Vehicle / Body Type <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.vehicleType}
              onChange={(value) => handleDropdownChange("vehicleType", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.children
              //     .toLowerCase()
              //     .localeCompare(optionB.children.toLowerCase())
              // }
            >
              {newCarVehicleTypes.map((vehicle, i) => (
                <Select.Option key={i} value={vehicle.value}>
                  {vehicle.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Engine CC :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Engine CC input value min 100 to max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={form.specifications?.engineCap?.value}
              onChange={(e) => {
                handleNumberFieldChange("engineCap", e.target.value, 4);
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>CC</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Power :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    {" "}
                    Power input value is max 9999.{" "}
                  </p>
                )}
              />
            </div>
            <Input
              type="number"
              value={form.specifications?.peakPower?.value}
              onChange={(e) => {
                handleNumberFieldChange(
                  "peakPower",
                  e.target.value,
                  "Power",
                  "engine",
                  5,
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>kw</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              {" "}
              Color <span>*</span> :
            </p>
            {/* <Select
              showSearch
              value={form.color}
              onChange={(value) => handleDropdownChange("color", value)}
              style={{ width: "100%" }}
              placeholder="-- Select --"
              options={colors}
            /> */}
            <Select
              showSearch
              value={form.color}
              onChange={(value) => handleDropdownChange("color", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {[{ value: "", label: "All" }, ...colors].map((el, i) => (
                <Select.Option key={i} value={el.value}>
                  {el.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Transmission <span>*</span>:
            </p>
            <Select
              showSearch
              value={form.specifications?.transmission?.value || null}
              onChange={(value) =>
                handleDropdownChange(
                  "transmission",
                  value,
                  "Transmission",
                  "transmission",
                )
              }
              style={{ width: "100%" }}
              placeholder="Search to Select."
            >
              <Select.Option value={"Automatic"}>Automatic</Select.Option>
              <Select.Option value={"Manual"}>Manual</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Manufacturing Year (Optional) : </p>
            <Select
              showSearch
              value={form.manufacturedYear}
              onChange={(value) =>
                handleDropdownChange("manufacturedYear", value)
              }
              style={{ width: "100%" }}
              placeholder={"Select launch year"}
            >
              {launchYears.map((el, i) => (
                <Select.Option key={i} value={el}>
                  {el}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Optional Label :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p>Label shall be displayed on the picture of car.</p>
                )}
              />
            </div>
            <Select
              value={form.option_label_1}
              onChange={(value) =>
                handleDropdownChange("option_label_1", value)
              }
              style={{ width: "100%" }}
              placeholder="-- Select --"
              options={[
                // { value: 'Electric Car', label: 'Electric Car' },
                // { value: '$0 Downpayment', label: '$0 Downpayment' },
                // { value: 'High Trade In', label: 'High Trade In' },
                { value: "Management Unit", label: "Management Unit" },
                { value: "Test Drive Unit", label: "Test Drive Unit" },
                { value: "Showroom Unit", label: "Showroom Unit" },
                // { value: 'Special Offer', label: 'Special Offer'}
              ]}
              allowClear
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div style={{ marginBottom: 10 }}>
              <Radio.Group
                onChange={(e) => handleRadioChange("videoType", e)}
                value={form.videoType}
              >
                <Radio value="youtube">Youtube</Radio>
                <Radio value="tiktok">Tiktok</Radio>
                <Radio value="local">Local Drive</Radio>
              </Radio.Group>
            </div>

            {form?.videoType == "tiktok" ? (
              <>
                <Input
                  value={form.tiktokVideo}
                  onChange={(text) => handleFieldChange("tiktokVideo", text)}
                  placeholder="Tiktok Video Link - Optional"
                />
                <p
                  className="form-field-label"
                  style={{ color: colorScheme.red, fontSize: 12, marginTop: 3 }}
                >
                  Video duration must not exceed 3 minutes!
                </p>
              </>
            ) : form?.videoType == "youtube" ? (
              <>
                <Input
                  value={form.youtubeVideo}
                  onChange={(text) => handleFieldChange("youtubeVideo", text)}
                  placeholder="Youtube Video Link - Optional"
                />
                <p
                  className="form-field-label"
                  style={{ color: colorScheme.red, fontSize: 12, marginTop: 3 }}
                >
                  Video duration must not exceed 3 minutes!
                </p>
              </>
            ) : (
              <>
                <VideoUploader
                  localVideoUrl={form.localVideoUrl}
                  handelVideoChange={handelVideoChange}
                />
              </>
            )}
          </div>
        </Col>

        {form.isElectric && (
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Drive Range : </p>
              <Input
                type="number"
                min="0"
                step="1"
                value={form.driveRange}
                onChange={(text) => handleFieldChange("driveRange", text)}
                suffix={
                  <div className="fieldPrefix">
                    <p>km</p>
                  </div>
                }
              />
            </div>
          </Col>
        )}

        {form.isHybrid && (
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Fuel Consumption : </p>
              <Input
                type="number"
                min="0"
                step="1"
                value={form.fuelConsumptionKilometer}
                onChange={(text) =>
                  handleFieldChange("fuelConsumptionKilometer", text)
                }
                suffix={
                  <div className="fieldPrefix">
                    <p>km/L</p>
                  </div>
                }
              />
            </div>
          </Col>
        )}
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isHybrid}
              onChange={(e) => onCheckboxChange("isHybrid", e)}
            >
              Hybrid
            </Checkbox>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isElectric}
              onChange={(e) => onCheckboxChange("isElectric", e)}
            >
              Electric
            </Checkbox>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isVerified}
              onChange={(e) => onCheckboxChange("isVerified", e)}
            >
              Trigger Email To Owner
            </Checkbox>
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isSendEmail}
              onChange={(e) => onCheckboxChange("isSendEmail", e)}
            >
              Trigger Email To All Sub
            </Checkbox>
          </div>
        </Col>
      </Row>

      {isEdit && saleAdvisers.length > 0 && (
        <>
          <Divider />

          <div className="header-container">
            <p className="header">Sale Advisers</p>
          </div>

          <Row>
            {saleAdvisers?.map((item, i) => (
              <Col span={8}>
                <div className="form-fields" style={{ margin: 0 }}>
                  <Checkbox
                    name={item}
                    checked={form?.productAgents?.find(
                      (agent) => agent.fullName === item.fullName,
                    )}
                    onChange={(e) => handleUpdateAgent(e)}
                    disabled
                  >
                    {item.fullName} - {item?.sorting}
                  </Checkbox>
                </div>
              </Col>
            ))}
          </Row>
        </>
      )}

      <Divider />

      <Row style={{ marginBottom: 20 }}>
        <Col span={6}>
          <PrimaryButton
            onClick={downloadFiles}
            color={colorScheme.green}
            label="Download Brochures"
            Icon={<FaDownload style={{ marginRight: "10px" }} />}
          />
        </Col>
      </Row>

      <Divider />

      <div className="header-container">
        <p className="header">Seller Notes (Optional) </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Features : </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    <strong>
                      Features refers to functions in-built in your vehicle.
                    </strong>
                    <br />
                    Eg: Airbags, ABS, reliable, 6 cylinder, 6 seater, Sunroof,
                    multi-function steering, 2 moonroof.
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.features}
              onChange={(text) => handleFieldChange("features", text)}
              maxLength={150}
              showCount
              placeholder="Eg: Airbags, ABS, reliable, 6 cylinder, 6 seater, Sunroof, multi-function steering, 2 moonroof."
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Accessories : </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    <strong>
                      Accessories refers to additional luxuries to your vehicle.
                    </strong>
                    <br />
                    Eg: 22' sports rims, Body kit, Spoiler, Leather Seats,
                    wireless phone charges.
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.accessories}
              onChange={(text) => handleFieldChange("accessories", text)}
              maxLength={150}
              showCount
              placeholder="Eg: 22' sports rims, full bodykit, new leather upholstery, wireless phone charges."
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label">Description : </p>
              <FieldSuffix
                TooltipData={() => (
                  <p>
                    <strong>
                      Description will appear in the main page, so it is the
                      most important comment to add.
                    </strong>
                    <br />
                    Eg: Urgent sales; 1 careful owner; Seldom driven; high Parf
                    rebate; New road tax; Regularly servicing at Agent; Price
                    negotiable; Please call to arrange a test-drive.
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.description}
              onChange={(text) => handleFieldChange("description", text)}
              maxLength={400}
              showCount
              placeholder="Eg: Urgent sales; 1 careful owner; Seldom driven; high Parf rebate; New road tax; Regularly servicing at Agent; Price negotiable; Please call to arrange a test-drive."
            />
          </div>
        </Col>
      </Row>

      {/* <Row>
        <div className="editor-container" style={{ marginBottom: 20 }}>
          <p className="form-field-label">
            Features <span></span> :{" "}
          </p>
          <Editor
            editorState={featEditorState}
            onEditorStateChange={handleFeatEditorChange}
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            toolbar={{
              inline: { inDropdown: false },
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: true },
              image: {
                component: ImageUploadComponent,
                previewImage: true,
                uploadEnabled: true,
                alt: { present: true, mandatory: true },
              },
            }}
          />
        </div>

        <div className="editor-container" style={{ marginBottom: 20 }}>
          <p className="form-field-label">
            Accessories <span></span> :{" "}
          </p>
          <Editor
            editorState={acceEditorState}
            onEditorStateChange={handleAcceEditorChange}
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            toolbar={{
              inline: { inDropdown: false },
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: true },
              image: {
                component: ImageUploadComponent,
                previewImage: true,
                uploadEnabled: true,
                alt: { present: true, mandatory: true },
              },
            }}
          />
        </div>

        <div className="editor-container" style={{ marginBottom: 20 }}>
          <p className="form-field-label">
            Description <span></span> :{" "}
          </p>
          <Editor
            editorState={descEditorState}
            onEditorStateChange={handleDescEditorChange}
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            toolbar={{
              inline: { inDropdown: false },
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: true },
              image: {
                component: ImageUploadComponent,
                previewImage: true,
                uploadEnabled: true,
                alt: { present: true, mandatory: true },
              },
            }}
          />
        </div>
      </Row> */}

      <Divider />
      <div>
        <div style={{ marginBottom: 10 }}>
          <div className="header-div">
            <p className="sub-header-text">
              The image should not exceed 2MB(megabyte) and has to be (.jpg ,
              .png) with a minimum size and same ratio of : 600 width x 300
              height.
            </p>
          </div>
        </div>
        <Row>
          <Col span={8}>
            <div className="form-fields">
              {!form.longAdImage1 ? (
                <div>
                  <div
                    className="upload-container col-div"
                    onClick={handleOpenGalleryLong1}
                  >
                    <FaUpload />
                    <p>UPLOAD LONG PHOTO</p>
                  </div>

                  <input
                    ref={fileUploaderLong1}
                    id="getFileLong1"
                    type="file"
                    hidden
                    onChange={handleImageChange1}
                  />
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      backgroundColor: "#FFFFFF",
                      height: 40,
                      width: 40,
                      margin: "0 auto",
                    }}
                    onClick={() => handleDeleteSelectedFile1()}
                  >
                    <IoMdCloseCircle
                      style={{ width: 30, height: 30, cursor: "pointer" }}
                    />
                  </div>
                  <img src={form.longAdImage1} style={{ width: "100%" }} />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <Divider />
    </div>
  );
};

export default NewCarDetails;
